// src/routes/Index.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout      from './AppLayout';
import RequiresAuth   from './RequiresAuth';
import { Home }       from '../pages';
import { authRoutes, contentRoutes } from './publicRoutes';
import { privateRoutes }  from './privateRoutes';
import { useAuthContext } from '../context';

export const Index = () => {
  const { token } = useAuthContext();

  return (
    <Routes>
      {/* everything under AppLayout so loader/navbar/footer remain consistent */}
      <Route element={<AppLayout />}>
        
        {/* 1) Public Home */}
        <Route path="/" element={<Home />} />

        {/* 2) Other public content pages */}
        {contentRoutes.map((r, i) => (
          <Route key={i} path={r.path} element={r.element} />
        ))}

        {/* 3) Auth pages (login/signup) */}
        {authRoutes.map((r, i) => (
          <Route
            key={i}
            path={r.path}
            element={
              token
                ? <Navigate to="/" replace />
                : r.element
            }
          />
        ))}

        {/* 4) Protected pages */}
        <Route element={<RequiresAuth />}>
          {privateRoutes.map((r, i) => (
            <Route key={i} path={r.path} element={r.element} />
          ))}
        </Route>

        {/* 5) Catch‑all fallback */}
        <Route
          path="*"
          element={
            token
              ? <Navigate to="/" replace />
              : <Navigate to="/login" replace />
          }
        />
      </Route>
    </Routes>
  );
};
